import React                        from 'react';

/* Called by the calendar component to render an individual event */
const eventContent = (ev) => {

    /* Working hours shading has no content of its own. Test the flag, not
     * display: availability, tasks and bookings are also background events
     * in whichever mode doesn't put them in the foreground. */
    if (ev.event.extendedProps.isWorkingHours) {
        return null;
    }

    const { apiEvent: { BookingID: bookingID, 
        CaseRef, PatientName = '', appointmentTypes = [] } = {},
        isAvailable, rotaMode, bookingAppTypeID, explicitColour, isInPast, confirmed,
        isBooking    }
        = ev.event.extendedProps

    let hover = null;
    if (bookingID) {
        hover = '' + CaseRef + ' (' + PatientName + ')';
    } else if (!isAvailable) {
        hover = ev.event.title;;
    } else {
        hover = appointmentTypes?.reduce((prev, curr) => prev + '\n' + curr?.Title, 'Available for:-');
    }

    const style = explicitColour ? { backgroundColor: explicitColour } : {};

    let classes = 'CalendarBlockBg';
    if (isInPast) {
        classes += ' InPast';
    }
    if (confirmed) {
        classes += ' Confirmed';
    } else if (isBooking) {
        classes += ' Unconfirmed';
    }
    if (isBooking) {
        classes += ' Booking';
    }
    if (isAvailable) {
        classes += ' Available';
    }
    if (rotaMode) {
        classes += ' RotaMode';
    }

    return (
        <div className={'CalendarBlock ' + classes} title={hover} >
            <div className={'CalendarBlockBg ' + classes} style={style} ></div>
            {<h1 className="CalendarBlockTitle" >{ev.event.title}</h1>}
            <AppointmentTypes appointmentTypes={appointmentTypes} rotaMode={rotaMode} bookingAppTypeID={bookingAppTypeID}/>
        </div>
    )
}

const AppointmentTypes = ({ appointmentTypes, rotaMode, bookingAppTypeID }) => {

    const classes = 'AppTypeList' + (rotaMode ? ' RotaMode' : ' DiaryMode');
    return <ul className={classes}  >
        {appointmentTypes
            .map(at => <AppointmentType key={at?.AppointmentTypeID} at={at} bookingAppTypeID={bookingAppTypeID} />)}
        </ul>
}

const AppointmentType = ({ at, bookingAppTypeID }) => {
    let classes = 'AppType';
    if (bookingAppTypeID && bookingAppTypeID === at.AppointmentTypeID) {
        classes += ' selected';
    }

    return <li className={classes}  ><div  className='AppTypeBg'></div><div className='AppTypeInner'>{true && at.Title}</div></li>
}

export default eventContent;
